import { HttpClient, HttpEvent } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { UploadAsyncJobModel } from 'src/app/model/upload-async-job.model';

@Injectable({
  providedIn: 'root'
})
export class PersonCreditsService {
  private url: string;

  constructor(private http: HttpClient) {
    this.url = environment.services_url;
  }

  getAll = () => {
    return this.http.get(`${this.url}/personCredit/list`)
      .pipe(
        map((resp: any) => resp)
      );
  }

  // carga asincrona (exclusiva de Personas y Créditos): el archivo se encola y se procesa en background.
  // reportProgress+observe:'events' para poder mostrar el % de subida HTTP mientras se envia el archivo.
  uploadAsync = (userName: string, file: File, replace: boolean): Observable<HttpEvent<any>> => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('userName', userName);
    formData.append('table', 'person-credits');
    formData.append('replace', String(replace));
    formData.append('userId', localStorage.getItem('com_token'));
    return this.http.post(`${this.url}/upload/save-async`, formData, {
      reportProgress: true,
      observe: 'events'
    });
  }

  getUploadStatus = (jobId: string) => {
    return this.http.get<{ data: UploadAsyncJobModel, codeHttpStatus: number, messageError: string }>(`${this.url}/upload/status/${jobId}`)
      .pipe(
        map((resp: any) => resp)
      );
  }

  downloadLayout = () => this.http.get(`${this.url}/personCredit/DownloadLayout`, { responseType: 'blob' });
}
